<template>
  <v-dialog v-model="dialog" width="700" persistent>
    <customDialog>
      <template v-slot:title>
        {{ 'タグを消去' }}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" @click="close">
        </button>
      </template>
      <template v-slot:body>
        <v-col class="ma-0 pa-0 tag_delete_body">
          <div class="tag_delete_text">
            {{ `「${tagName}」のタグを消去します。` }}
          </div>
          <v-row class="ma-0 pa-0 mt-12 pb-4" justify="center">
            <v-btn class="tag_delete_cancel_btn" width="8rem" height="2.5rem" depressed
              @click="close">{{ 'キャンセル' }}</v-btn>
            <v-btn class="tag_delete_confirm_btn ml-3" width="8rem" height="2.5rem" depressed
              :loading="loading" @click="$emit('confirm')">{{ '消去' }}</v-btn>
          </v-row>
        </v-col>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import customDialog from '@/components/Modal.vue';
// 태그 삭제 확인 공통 다이얼로그. 삭제 실행 로직은 부모가 @confirm 에서 처리한다.
export default {
  components: {
    customDialog
  },
  props: {
    visible: Boolean,
    tagName: { type: String, default: '' },
    loading: Boolean,
  },
  data: () => ({
    dialog: false,
  }),
  watch: {
    visible(v) {
      this.dialog = v;
    },
    dialog(v) {
      if (v !== this.visible) this.$emit('visible', v);
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.tag_delete_body {
  min-height: 150px;
}

.tag_delete_text {
  color: white;
  text-align: center;
  padding: 1rem 1.5rem;
  margin-top: 0.5rem;
  font-size: 1rem;
}

.tag_delete_cancel_btn {
  background-color: #4E4E4E !important;
  color: white !important;
}

.tag_delete_confirm_btn {
  background-color: #CA4848 !important;
  color: white !important;
}
</style>
